// extracted by mini-css-extract-plugin
export default {"main":"Mba-z"};